export default {
  defaultAvatar: 'obs_788803316800001604656483$prod-public-res',
  noDataImg: require('assets/img/common/pic_no_data@3x.png'),
  noDataImg2: 'https://obs.prod.ubanquan.cn/obs_382703595600001680837760_pre$prod-ubq',
  synthesisNoDataImg: require('assets/img/common/zhanwushuju@3x.png'),
  noDataText: '暂无数据',
  videoDefaultImg: require('@/assets/img/special/video-default@2x.png')
};